/*  Article Blocks Start */
export const GET_ARTICLE_BLOCKS_REQUEST = 'GET_ARTICLE_BLOCKS_REQUEST';
export const GET_ARTICLE_BLOCKS_SUCCESS = 'GET_ARTICLE_BLOCKS_SUCCESS';
export const GET_ARTICLE_BLOCKS_FAIL = 'GET_ARTICLE_BLOCKS_FAIL';

export function getArticleBlocksRequest(payload = {}) {
  return {
    type: GET_ARTICLE_BLOCKS_REQUEST,
    payload,
  };
}

export const CREATE_ARTICLE_BLOCK = 'CREATE_ARTICLE_BLOCK';
export const UPDATE_ARTICLE_BLOCK = 'UPDATE_ARTICLE_BLOCK';
export const DELETE_ARTICLE_BLOCK = 'DELETE_ARTICLE_BLOCK';
export function createArticleBlock(payload = {}) {
  return {
    type: CREATE_ARTICLE_BLOCK,
    payload,
  };
}
export function updateArticleBlock(payload = {}) {
  return {
    type: UPDATE_ARTICLE_BLOCK,
    payload,
  };
}
export function deleteArticleBlock(payload = {}) {
  return {
    type: DELETE_ARTICLE_BLOCK,
    payload,
  };
}
/*  Article Blocks End */

/*  Articles Start */
export const GET_ARTICLES_REQUEST = 'GET_ARTICLES_REQUEST';
export const GET_ARTICLES_SUCCESS = 'GET_ARTICLES_SUCCESS';
export const GET_ARTICLES_FAIL = 'GET_ARTICLES_FAIL';

export function getArticlesRequest(payload = {}) {
  return {
    type: GET_ARTICLES_REQUEST,
    payload,
  };
}

export const CREATE_ARTICLE = 'CREATE_ARTICLE';
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE';
export const DELETE_ARTICLE = 'DELETE_ARTICLE';
export function createArticle(payload = {}) {
  return {
    type: CREATE_ARTICLE,
    payload,
  };
}
export function updateArticle(payload = {}) {
  return {
    type: UPDATE_ARTICLE,
    payload,
  };
}
export function deleteArticle(payload = {}) {
  return {
    type: DELETE_ARTICLE,
    payload,
  };
}
/*  Articles End */
